import React from 'react';
import { InputBase, Typography } from "@mui/material";
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
import { useDebouncedCallback } from "beautiful-react-hooks";
import { isTablet } from 'react-device-detect';

const InputIcon = ({
  disabled = false,
  value,
  placeholder,
  sx,
  inputLabel,
  size,
  rightIcon,
  leftIcon,
  sxIcon,
  onChange,
  onFocus,
  onBlur,
  required = false,
  name,
  type = 'text',
  notes = null
}) => {

  const handleScrollOnBlur = useDebouncedCallback((event) => {
    if (isTablet) {
      window.scrollTo(0, -65)
    }

    if (typeof onBlur == 'function') {
      onBlur(event.target.value);
    }

  });

  return (
    <Div sx={{
      position: 'relative',
      width: '100%',
      ...sx
    }}>
      <Typography variant={"body1"} fontWeight={500} mb={1} fontSize={12}>{inputLabel}{required && <span style={{ fontWeight: 'bold', fontSize: 14, color: 'red' }}> *</span>}</Typography>
      <Div sx={{ position: 'relative' }}>
        {leftIcon &&
          <Div sx={{
            position: 'absolute',
            top: 11,
            left: 10,
            color: '#C21B17',
            cursor: 'pointer',
            zIndex: 5,
            ...sxIcon,
            '&:hover': {
              color: '#ADADAD'
            }
          }}>
            {leftIcon}
          </Div>
        }
        <InputBase
          type={type}
          name={name}
          onFocus={onFocus}
          onBlur={handleScrollOnBlur}
          placeholder={placeholder}
          fullWidth
          disabled={disabled}
          size={size}
          value={value}
          onChange={onChange}
          sx={{
            color: 'inherit',
            display: 'flex',
            backgroundColor: disabled ? '#eee' : '#FFFFFF',
            borderRadius: '8px',

            '& .MuiInputBase-input': {
              padding: theme => theme.spacing(1, 1, 1, 0),
              paddingLeft: leftIcon ? theme => `calc(1em + ${theme.spacing(4)})` : theme => `calc(1em + ${theme.spacing(1)})`,
              paddingRight: rightIcon ? theme => `calc(1em + ${theme.spacing(3)})` : theme => `calc(1em + ${theme.spacing(1)})`,
              transition: theme => theme.transitions.create('width'),
              width: '100%',
              height: size == 'small' ? 19 : 30,
              border: "1px solid #ADADAD",
              borderRadius: 2,
              fontSize: size == 'small' ? 12 : 12,
              fontWeight: 600
            },

            '&.Mui-focused .MuiInputBase-input': {
              border: "1px solid #4285F4",
            },
          }}
        />
        {rightIcon &&
          <Link sx={{
            position: 'absolute',
            top: 11,
            right: 18,
            color: '#C21B17',
            cursor: 'pointer',
            zIndex: 5,
            ...sxIcon,
            '&:hover': {
              color: '#ADADAD'
            }
          }}>
            {rightIcon}
          </Link>
        }
        {notes && notes}
      </Div>
    </Div>
  );
};

export default InputIcon;
